import { useEffect, useState } from "react";
import styles from "./flags_modal.module.css";

import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import { Dialog, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { post } from "util/requests";
import { corelab_api_url } from "config";
import { Checkbox } from "@mui/material";

export default function FlagsModal(props) {
  const { isOpen, close, onYes, data, allFilesList, selectedFile, handleModifyFlags } = props;
  const [value, setValue] = useState((data && data.length && data[0].name) || "");
  const [loading, setLoading] = useState(false);

  const [currentFlags, setCurrentFlags] = useState([]);

  useEffect(() => {
    data && data.length && setValue(data && data.length && data[0].name);
  }, [data, isOpen]);

  const is_file = true; //data[0]?.type === "file";
  let extension = (is_file && value.split(".").slice(-1)[0]) || "";

  useEffect(() => {
    setCurrentFlags((selectedFile?.flags && [...selectedFile.flags]) || []);
  }, [selectedFile.uuid]);

  return (
    <Dialog open={isOpen} onClose={close}>
      <div className={styles.wrapper}>
        <div className={styles.modal_wrapper}>
          <div className={styles.modal_title}>{`Modify Flags`}</div>
          <div className={styles.modal_body}>
            <div>
              {["downloaded", "imaging_qc", "deidentified", "read", "segmented"].map((flag) => (
                <div
                  className={styles.flag_wrapper}
                  onClick={() => {
                    if (currentFlags.includes(flag)) {
                      setCurrentFlags(currentFlags.filter((f) => f !== flag));
                    } else {
                      let _tmp = [...currentFlags];
                      _tmp.push(flag);
                      setCurrentFlags(_tmp);
                    }
                  }}
                >
                  <div>
                    <Checkbox checked={currentFlags.includes(flag)} />
                  </div>
                  <div>{flag.toUpperCase()}</div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.modal_button_wrapper}>
            <LoadingButton
              disabled={false}
              variant="contained"
              loading={loading}
              onClick={() => {
                setLoading(true);
                handleModifyFlags(selectedFile.uuid, currentFlags).then(() => {
                  setLoading(false);
                  close();
                });
              }}
            >
              Modify Flags
            </LoadingButton>
            <LoadingButton
              disabled={false}
              variant="outlined"
              loading={false}
              onClick={() => {
                close();
              }}
            >
              Cancel
            </LoadingButton>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
